var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropzone",class:{ dragging: _vm.dragging }},[(_vm.dragging)?_c('tooltip',{attrs:{"position":_vm.tooltipPosition}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }